import { Riksvegrute } from '@/domain/omrader';
import type { Riksvegrute as ApiRiksvegrute } from '@/generated/nvdb/vegobjekter/models';

export function transformRiksvegrute(data: null | undefined): null;
export function transformRiksvegrute(data: ApiRiksvegrute): Riksvegrute;
export function transformRiksvegrute(
    data: ApiRiksvegrute | null | undefined
): Riksvegrute | null {
    if (!data) return null;
    return new Riksvegrute(data.riksvegrute, data.enumid);
}

export function transformRiksvegruter(riksvegruter: ApiRiksvegrute[]): Riksvegrute[] {
    return riksvegruter.map(rv => transformRiksvegrute(rv));
}
